<template>
  <v-card class="rounded-lg fill-height">
    <v-row
      no-gutters
      class="pa-6"
      align="center"
    >
      <v-col>
        <div class="subtitle-2 grey--text font-weight-regular">
          {{ title }}
        </div>
        <div
          v-if="loading"
          class="mt-3"
        >
          <v-progress-circular
            indeterminate
            :size="40"
            color="primary"
            :width="2"
          />
        </div>
        <div v-else>
          <div
            v-if="(value !== undefined && value !== null) || valueText !== undefined"
            class="text-h4 mt-2 grey--text text--darken-2"
          >
            <div v-if="!$slots.default">
              {{ valueText || value }}
            </div>
            <slot v-else />
          </div>
          <div
            v-else
            class="text-h4 mt-2 grey--text"
          >
            N/A
          </div>
          <!--          <div-->
          <!--            v-if="visual && max"-->
          <!--            class="mt-4"-->
          <!--          >-->
          <!--            <v-progress-linear-->
          <!--              :height="8"-->
          <!--              rounded-->
          <!--              background-color="grey"-->
          <!--              :background-opacity=".2"-->
          <!--              :color="color"-->
          <!--              :value="(value / max) * 100"-->
          <!--            />-->
          <!--          </div>-->
        </div>
      </v-col>
      <v-col cols="auto">
        <v-icon
          v-if="trend"
          x-large
          color="success"
        >
          fal fa-arrow-trend-{{ trend }}
        </v-icon>
      </v-col>
    </v-row>
  </v-card>
</template>
<script>
export default {
  name: 'StatCard',
  props: {
    title: {
      type: String,
      default: ''
    },
    value: {
      type: [Number, String],
      default: undefined
    },
    valueText: {
      type: String,
      default: undefined
    },
    trend: {
      type: String,
      default: undefined
    },
    loading: {
      type: Boolean,
      default: false
    },
    visual: {
      type: Boolean,
      default: true
    },
    color: {
      type: String,
      default: undefined
    },
    max: {
      type: Number,
      default: undefined
    }
  }
}
</script>
